import { render, staticRenderFns } from "./afterSalesDetail.vue?vue&type=template&id=5c51693c"
import script from "./afterSalesDetail.vue?vue&type=script&lang=js"
export * from "./afterSalesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports